<template>
<div>
    <b-table 
        striped 
        hover 
        selectable 
        select-mode="single" 
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :per-page="perPage"
        :current-page="currentPage"
        @row-selected="onRowSelected">
            <template v-slot:cell(infopoint)="data">
                <infopointCell v-bind:infopointId="parseInt(data.value)"/>
            </template>
    </b-table>
    
    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
        
</div>
</template>

<script>
import TablePagination from '@/components/Misc/TablePagination'
import device from '@/store/displays/device'
import infopointCell from '@/components/Display/InfopointCell'

export default {
    name: 'deviceListTable',
    components: {
        TablePagination, infopointCell
    },
    props: ['filter'],
    data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            fields: [
                { key:"deviceId" , label:"Id", sortable:"true" },
                { key:"name" , label:"name", sortable:"true" },
                { key:"description" , label:"description"},
                { key:"type" , label:"type"} ,
                { key:"infopoint" , label:"infopoint" , 
                 formatter: (value, key, item) => {
                     var ret = "";
                     if( item.attributes != null ) {
                        for( var a of item.attributes ) {
                            if( a.name == "INFOPOINT_ID") {
                                ret = a.value;
                                break;
                            }
                        }
                    }
                     return ret;
                    //return new Date().getFullYear() - item.age
                } }
                ],
            sortBy:"deviceId"
        }
    },
    computed: {
        items () { 
            return this.$store.state.device.deviceList;
        },
        totalRows() {
            return this.items ? this.items.length : 0;
        }               
    },
    created() {
        if (!this.$store.state.device) {
            this.$store.registerModule("device" , device);
        }
        this.$store.dispatch('device/getDeviceList');
    },
    methods: {
        onRowSelected: function(items) {
            this.$emit('selectItem', items[0]);
        },
        onFiltered(filteredItems) {        
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page){
            this.currentPage = page
        }        
    }
}

</script>